import { Component, computed, inject } from '@angular/core';
import { LocationDetailsPage } from '../location-details-page/location-details-page';
import { LocationDetailsEditForm } from '../../components/location-details-edit-form/location-details-edit-form';
import { Button, NotificationService, ConfirmService, Skeleton } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { Router } from '@angular/router';
import { LocationsStore } from '../../store/locations.store';
import { EditFormSkeleton } from '../../../../shared/components/edit-form-skeleton/edit-form-skeleton';

@Component({
  selector: 'app-location-details-general-page',
  templateUrl: './location-details-general-page.html',
  imports: [LocationDetailsEditForm, Button, NgIcon, TranslocoPipe, EditFormSkeleton, Skeleton],
})
export class LocationDetailsGeneralPage {
  private router = inject(Router);
  private notificationService = inject(NotificationService);
  private confirmService = inject(ConfirmService);
  private locationsStore = inject(LocationsStore);
  private translocoService = inject(TranslocoService);

  private locationDetailsPage = inject(LocationDetailsPage);

  protected locationId = this.locationDetailsPage.locationId;
  protected organizationId = this.locationDetailsPage.organizationId;

  protected locationState = computed(() =>
    this.locationsStore.locations()?.find((loc) => loc.id === this.locationId()),
  );

  protected isDeleteLoading = computed(() => this.locationState()?.isDeleteLoading || false);

  protected async onClickDelete() {
    const confirmMessage = this.translocoService.translate(
      'cockpit.locations.details.general.deleteConfirmDialog.message',
    );
    const title = this.translocoService.translate(
      'cockpit.locations.details.general.deleteConfirmDialog.title',
    );
    const confirmButtonText = this.translocoService.translate(
      'cockpit.locations.details.general.deleteConfirmDialog.confirmButton',
    );
    const cancelButtonText = this.translocoService.translate(
      'cockpit.locations.details.general.deleteConfirmDialog.cancelButton',
    );
    const confirm = await this.confirmService.confirm({
      title,
      message: confirmMessage,
      mode: 'destructive',
      icon: 'heroTrash',
      confirmButtonText,
      cancelButtonText,
    });
    if (!confirm) {
      return;
    }
    try {
      await this.locationsStore.delete(this.locationId());
      const successMsg = this.translocoService.translate(
        'cockpit.locations.details.general.deleteSuccess',
      );
      this.notificationService.showSuccess({
        title: successMsg,
      });
      this.router.navigate(['/organizations', this.organizationId(), 'locations'], {
        replaceUrl: true,
      });
    } catch (error) {
      console.error('Error deleting location:', error);
      const errorMsg = this.translocoService.translate(
        'cockpit.locations.details.general.deleteError',
      );
      this.notificationService.showError({
        title: errorMsg,
      });
    }
  }
}
